import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

const COOKIE_KEY = 'hm_uid';
const LS_META_KEY = 'hm_uid_meta';
const EXPIRES_DAYS = 30;
const EXPIRES_MS = EXPIRES_DAYS * 24 * 60 * 60 * 1000;

function _refreshCookie(uid) {
  try {
    Cookies.set(COOKIE_KEY, uid, { expires: EXPIRES_DAYS, sameSite: 'Lax' });
  } catch (_) { /* cookie access blocked */ }
}

function _refreshLocalStorage(uid) {
  try {
    localStorage.setItem(LS_META_KEY, JSON.stringify({
      uid,
      expiresAt: Date.now() + EXPIRES_MS,
    }));
  } catch (_) { /* localStorage access blocked */ }
}

/**
 * Returns the existing session UID without creating a new one.
 * Returns null if no UID exists or all storage is blocked.
 * Use this when there is no meta-channel context (DSGVO: no identifier without purpose).
 */
export function getExistingUid() {
  try {
    const cookieUid = Cookies.get(COOKIE_KEY);
    if (cookieUid) {
      _refreshCookie(cookieUid);
      _refreshLocalStorage(cookieUid);
      return cookieUid;
    }
  } catch (_) { /* cookie access blocked */ }

  try {
    const raw = localStorage.getItem(LS_META_KEY);
    if (raw) {
      const meta = JSON.parse(raw);
      if (meta && meta.uid && meta.expiresAt > Date.now()) {
        _refreshCookie(meta.uid);
        _refreshLocalStorage(meta.uid);
        return meta.uid;
      }
    }
  } catch (_) { /* localStorage access blocked */ }

  return null;
}

/**
 * Returns the existing UID or creates a new one.
 * Only call this when there is a concrete meta-channel tracking purpose (e.g. trv_reference present).
 * Expiry is extended by 30 days on every access.
 */
export function getOrCreateUid() {
  const existing = getExistingUid();
  if (existing) return existing;

  const uid = uuidv4();
  _refreshCookie(uid);
  _refreshLocalStorage(uid);
  return uid;
}
